import {
  superClientsMenu,
  DefaultToolTipBoxWidth,
  LargeToolTipBox,
} from "../helpers/constant";

export default {
  methods: {
    onChangeChartTab(
      tabId,
      yAxisLabel,
      component,
      legendItems,
      legendColors,
      config
    ) {
      this.linePlotData = [];
      this.chartProperties = {};

      if (component == "chart-bar") {
        this.chartProperties = this.GetBarChartProperties(
          this.chartData[tabId],
          legendItems,
          legendColors,
          yAxisLabel
        );
        this.chartProperties.width = DefaultToolTipBoxWidth;
        this.chartGraphData = this.chartData[tabId]
          ? this.chartData[tabId].data
          : null;
      } else if (component == "chart-bar-line") {
        this.chartProperties = this.GetBarChartProperties(
          this.chartData[tabId],
          legendItems,
          legendColors,
          yAxisLabel
        );

        this.chartProperties.lineColor = config.lineColor[0];
        this.chartProperties.width = LargeToolTipBox;
        this.chartGraphData = this.chartData[tabId]
          ? this.chartData[tabId].data
          : null;
        this.linePlotData = this.chartData[tabId].lineData;
      } else if (component == "chart-time-series") {
        this.chartProperties = this.getTimeSeriesProperties(legendColors);
        this.chartGraphData = this.chartData[tabId]
          ? this.chartData[tabId].data
          : null;
      }

      if (component == "chart-area") {
        this.chartProperties = this.GetAreaChartProperties(
          this.chartData[tabId],
          legendItems,
          yAxisLabel
        );
        this.chartGraphData = this.chartData[tabId]
          ? this.chartData[tabId].data
          : null;
      }
    },
    getMenuType(MenuId) {
      let menu = MenuId;
      for (const element of superClientsMenu) {
        if (element.subMenu.length > 0) {
          let index = element.subMenu.findIndex((x) => x.id == MenuId);
          if (index >= 0) {
            menu = element.id;
            return menu;
          }
        } else {
          if (element.id == MenuId) {
            menu = element.id;
            return menu;
          }
        }
      }
    },
  },
};
